"use client";

import { useCallback, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export function useExternalLinkConfirm() {
  const [pendingUrl, setPendingUrl] = useState<string | null>(null);
  const request = useCallback((url: string) => setPendingUrl(url), []);
  const close = useCallback(() => setPendingUrl(null), []);
  const confirm = useCallback(() => {
    if (pendingUrl) {
      window.open(pendingUrl, "_blank", "noopener,noreferrer");
    }
    setPendingUrl(null);
  }, [pendingUrl]);

  return { pendingUrl, request, close, confirm };
}

export function ExternalLinkConfirmDialog({
  url,
  open,
  onClose,
  onConfirm,
}: {
  url: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="external-link-title">
      <DialogTitle id="external-link-title">Abrir site externo?</DialogTitle>
      <DialogContent>
        <Typography>
          Você está prestes a sair do Análise de FIIs Pro e abrir um site de
          terceiros.
        </Typography>
        <Typography
          component="div"
          sx={{ overflowWrap: "anywhere", my: 1.5, fontFamily: "monospace" }}
        >
          {url}
        </Typography>
        <Typography color="text.secondary">
          Não temos controle sobre o conteúdo ou a segurança desse site.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={onConfirm} autoFocus>
          Abrir em nova aba
        </Button>
      </DialogActions>
    </Dialog>
  );
}
